import React, { Component } from 'react';
import Icon from '@atlaskit/icon/glyph/radio';
import { IconWrapper } from './styled/Radio';
export default class RadioIcon extends Component {
    render() {
        const { isActive, isChecked, isDisabled, isFocused, isHovered, isInvalid, } = this.props;
        return (React.createElement(IconWrapper, { isActive: isActive, isChecked: isChecked, isDisabled: isDisabled, isFocused: isFocused, isHovered: isHovered, isInvalid: isInvalid },
            React.createElement(Icon, { label: "", primaryColor: "inherit", secondaryColor: "inherit" })));
    }
}
//# sourceMappingURL=RadioIcon.js.map